module.exports = __webpack_public_path__ + "img/1020803064.8f64fc94.png";